import { useEffect } from 'react'
import { isEmpty } from 'utils/UtilsFunction'
import './CustomerTitle.scss'
/**
 * @file 고객지원 title, sub 컴포넌트
 */
function CustomerTitle({ title, sub }) {
    return (
        <>
            <div className="customer-body-title">{title}</div>
            {!isEmpty(sub) && <div className="customer-body-sub" dangerouslySetInnerHTML={{ __html: sub }}></div>}
        </>
    )
}

export default CustomerTitle
